import React from 'react'

const useWebSocket = ({
  defaultParams,
  roomId,
  fractalId,
  getMessagesRSPA,
  setIsConnected,
  isConnected,
  replaceMessage,
  isAdmin
}) => {
  const [messages, setMessages] = React.useState([])
  const socketRef = React.useRef(null)
  const reconnectTimeoutRef = React.useRef(null)
  const isManuallyClosedRef = React.useRef(false)
  const [error, setError] = React.useState(null)
  const [currentPage, setCurrentPage] = React.useState(1)
  const url = `${
    process.env.REACT_APP_PROJECT_MESSAGE_HOST
  }/cable?room=${roomId}&fractal_id=${fractalId}${
    isAdmin ? '&is_admin=true' : ''
  }`

  function connect () {
    try {
      socketRef.current = new WebSocket(url)
      socketRef.current.onopen = () => {
        const subscribeMessage = JSON.stringify({
          command: 'subscribe',
          identifier: JSON.stringify({
            channel: 'RoomChannel',
            room: roomId
          })
        })
        socketRef.current.send(subscribeMessage)
        setIsConnected(true)
      }
      socketRef.current.onerror = event => {
        setIsConnected(false)
      }
      socketRef.current.onmessage = event => {
        const data = JSON.parse(event.data)
        if (data.type === 'ping') return
        if (data.message) {
          const { id, ...rest } = data.message.message
          const isModeratedMsg =
            rest.moderation_status === 'accepted' ||
            rest.moderation_status === 'refused'
          setMessages(prevMessages => {
            let newValue = [
              ...prevMessages,
              rest.message_type !== 'system' &&
                !isModeratedMsg && {
                  id: id,
                  ...rest
                }
            ].filter(item => !!item)
            if (isModeratedMsg) {
              newValue = replaceMessage(newValue, { id, ...rest })
            }
            return newValue
          })
        }
      }

      socketRef.current.onclose = event => {
        if (!isManuallyClosedRef.current && !isConnected) {
          reconnectTimeoutRef.current = setTimeout(() => {
            connect()
          }, 1000)
        } else {
          socketRef.current?.close()
          setIsConnected(false)
        }
      }
    } catch (error) {
      setIsConnected(false)
      console.error('Erro ao conectar ao WebSocket', error)
      setError(error)
    }
  }

  React.useEffect(() => {
    if (roomId) {
      getMessagesRSPA({
        params: {
          'page[number]': currentPage,
          ...defaultParams
        },
        roomId: roomId
      }).then(res => {
        setMessages(res.data.reverse())
      })
    }
  }, [])

  React.useEffect(
    () => {
      connect()

      return () => {
        isManuallyClosedRef.current = true
        socketRef.current?.close()
        clearTimeout(reconnectTimeoutRef.current)
      }
    },
    [url]
  )
  return { messages, error, setMessages, currentPage, setCurrentPage }
}

export default useWebSocket
